module.exports = __webpack_public_path__ + "img/if_5.5c228cd2.png";